import { Flex, Table } from 'antd';
import { useEffect, useState } from 'react';

const columnsDropoff = [
  {
    title: 'Service',
    dataIndex: 'service',
    key: 'service',
  },
  {
    title: 'US Domestic',
    children: [
      {
        title: 'Screened',
        dataIndex: 'usDomesticScreened',
        key: 'usDomesticScreened',
        width: 110,
      },
      {
        title: 'Unscreened',
        dataIndex: 'usDomesticUnscreened',
        key: 'usDomesticUnscreened',
        width: 110,
      },
    ],
  },
  {
    title: 'International',
    children: [
      {
        title: 'Screened',
        dataIndex: 'internationalScreened',
        key: 'internationalScreened',
        width: 110,
      },
      {
        title: 'Unscreened',
        dataIndex: 'internationalUnscreened',
        key: 'internationalUnscreened',
        width: 110,
      },
    ],
  },
];

const columnsPickup = [
  {
    title: 'Service',
    dataIndex: 'service',
    key: 'service',
  },
  {
    title: 'US Domestic',
    dataIndex: 'usDomestic',
    key: 'usDomestic',
  },
  {
    title: 'International',
    dataIndex: 'international',
    key: 'international',
  },
];

const TimesTable = ({ data = [], selectedTab }) => {
  const [dataDropoff, setDataDropoff] = useState([]);
  useEffect(() => {
    const formattedData = Object.entries(data).map(
      ([service, times], index) => ({
        key: String(index + 1), // Unique key for each row
        service: service, // Service name (e.g., "Human Remains")
        usDomesticScreened: times.domPrescreenedTime || 'N/A', // US Domestic Screened
        usDomesticUnscreened: times.domMinDropOffTime || 'N/A', // US Domestic Unscreened
        internationalScreened: times.intPrescreenedTime || 'N/A', // International Screened
        internationalUnscreened: times.intMinDropOffTime || 'N/A', // International Unscreened
      })
    );
    setDataDropoff(formattedData); // Set formatted data to state
  }, [data]);

  const [dataPickup, setDataPickup] = useState([]);

  useEffect(() => {
    if (data?.length) {
      const transformedDataPickup = data.map((item, index) => ({
        key: index + 1,
        service: item.serviceType,
        usDomestic: item.screenedTime || 'N/A',
        international: item.unScreenedTime || 'N/A',
      }));

      setDataPickup(transformedDataPickup);
    }
  }, [data]);

  return (
    <>
      <Flex vertical gap={12}>
        {selectedTab === 'dropoff' ? (
          <Table
            columns={columnsDropoff}
            dataSource={dataDropoff}
            pagination={false}
            bordered
            className='zl-custom-times-table'
          />
        ) : (
          <Table
            columns={columnsPickup}
            dataSource={dataPickup}
            pagination={false}
            bordered
            className='zl-custom-times-table'
          />
        )}
      </Flex>
    </>
  );
};

export default TimesTable;
